import {
  GTM_FACILITY_FILTER_TYPE_ACTION,
  GTM_FACILITY_TAB_NAME
} from "@/enums/gtm-events";

export default {
  [GTM_FACILITY_TAB_NAME.ALL_LOCATIONS]:
    GTM_FACILITY_FILTER_TYPE_ACTION.ALL_LOCATIONS,
  [GTM_FACILITY_TAB_NAME.CITY]: GTM_FACILITY_FILTER_TYPE_ACTION.CITY,
  [GTM_FACILITY_TAB_NAME.LOCATIONS_GROUP]:
    GTM_FACILITY_FILTER_TYPE_ACTION.LOCATIONS_GROUP,
  [GTM_FACILITY_TAB_NAME.LOCATION]: GTM_FACILITY_FILTER_TYPE_ACTION.LOCATION
};
